import React, { useCallback, useContext, useState } from "react";
import {
  IonButtons,
  IonContent,
  IonHeader,
  IonMenuButton,
  IonPage,
  IonTitle,
  IonToolbar,
} from "@ionic/react";

import { AddressSearch } from "@/modules/location/components";

type Props = {};

const searchOptions = {
  types: ["address"],
  // componentRestrictions: { country: "il" },
};

export function ConfigLocationPage(props: Props) {
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>

          <IonTitle>רשימת כתובות</IonTitle>

          <IonButtons slot="end" />
        </IonToolbar>
      </IonHeader>

      <IonContent className="ion-padding">{/* <AddressSearch /> */}</IonContent>
    </IonPage>
  );
}
